module.exports = __webpack_public_path__ + "img/banner-subscribe.712abfb7.jpg";